import React from 'react';
import ExcelImport from './ExcelImport';
import ExcelImportProvider from './ExcelImportContext';

let Index = () => {
    return (
        <ExcelImportProvider>
            <ExcelImport />
        </ExcelImportProvider>
    )
}

export default Index;